// web_components/wcPanoramic/wcPanoramic_Renderer.ts

/**
 * Generates the HTML for the wc-panoramic component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	// Check if 'css' exists in dataAttributes and is an object
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables and assign to 'variables', defaulting to an empty object if undefined
	const variables = dataAttributes.variables || {};

	return `
        ${styleTag}
        <section id="${instanceId}" class="wc-panoramic">
		    <h2 class="wc-panoramic__heading">${variables.heading}</h2>
		    <figure>
				<picture>
					<source media="(min-width: 1200px)" srcset="${variables.imageLarge}" />
					<source media="(min-width: 640px)" srcset="${variables.imageMedium}" />
					<img src="${variables.imageSmall}" alt="${variables.imageCaption ? '' : variables.imageAlt}" aria-describedby="wc-panoramic__description" />
				</picture>
				${
					variables.imageCaption
						? `
			    <figcaption id="wc-panoramic__description" class="sr-only">${variables.imageCaption}</figcaption>`
						: ''
				}
		    </figure>
		</section>
    `;
}
